exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".car {\n  display: block;\n  width: 24%;\n  padding: 10px;\n  border: 1px dotted #ddd;\n  text-align: center;\n  text-decoration: none;\n  color: #2e76da;\n  border-radius: 4px;\n  float: left;\n  margin-bottom: 10px;\n  margin-right: 10px;\n}\n\n.car .image {\n  display: block;\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.car:nth-child(4n) {\n  margin-right: 0;\n}\n\n.car:nth-child(4n+1) {\n  clear: left;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/baylorrae/code/tutorials/graphcool/garage/src/app/car-list/car-list.component.css
// module id = ../../../../../src/app/car-list/car-list.component.css
// module chunks = main